import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { GaranLogService } from 'src/app/core/garan-log.service';
import { QineticPositionService } from 'src/app/core/qinetic-position.service';
import { UtilsService } from 'src/app/core/utils.service';

@Component({
  selector: 'app-orders-qinetic-dialog',
  templateUrl: './orders-qinetic-dialog.component.html',
  styleUrls: ['./orders-qinetic-dialog.component.scss'],
})
export class OrdersQineticDialogComponent {
  qinetic_position_id?: string;
  buyer_id?: string;
  order_id?: string;
  is_qinetic_read_running: boolean = true;
  qinetic_position?: any;

  constructor(
    private dialog_ref: MatDialogRef<OrdersQineticDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: any,
    private qinetic_position_service: QineticPositionService,
    private garan_log_service: GaranLogService,
    private error_service: ErrorService,
    private utils_service: UtilsService,
  ) {
    this.qinetic_position_id = data.qinetic_position_id;
    this.buyer_id = data.buyer_id;
    this.order_id = data.order_id;
  }

  ngOnInit(): void {
    if (this.buyer_id) {
      this.createGaranLog(this.buyer_id);
    }

    if (this.qinetic_position_id && this.buyer_id) {
      this.readQineticPosition(this.qinetic_position_id, this.buyer_id);
    }
  }

  onCloseClick(): void {
    this.dialog_ref.close();
  }

  readQineticPosition(qinetic_position_id: string, buyer_id: string): void {
    this.is_qinetic_read_running = true;
    this.qinetic_position_service.read(qinetic_position_id, buyer_id).subscribe({
      next: response => {
        this.qinetic_position = response.data;
        this.is_qinetic_read_running = false;
      },
      error: error => {
        const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
        this.dialog_ref.close({ error: processed_error });
        this.is_qinetic_read_running = false;
      },
    });
  }

  createGaranLog(buyer_id: string): void {
    const admin_email = this.utils_service.getProfileEmail();
    this.garan_log_service.create(buyer_id, admin_email).subscribe({
      next: () => {},
      error: () => {},
    });
  }
}
